<template>
  <router-view></router-view>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import get from 'lodash-es/get'
import '@/assets/scss/main.scss'

export default {
  async mounted() {
    await this.resetPolicies()
  },
  computed: {
    ...mapState('auth', ['role', 'user', 'policies']),
  },
  methods: {
    ...mapActions('auth', ['checkAuthPolices']),
    async resetPolicies() {
      const roleId = get(this.user, 'role.id', '')
      if (typeof roleId === 'string' && roleId.length) await this.checkAuthPolices({ roleId: this.user.role.id })
    },
  },
}
</script>
